export default function(params) {
  const query = Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');
  return query;
}


// WEBPACK FOOTER //
// ./src/lib/convertObjectToParams.js